export default __webpack_public_path__ + "images/3f5a6ba67d77ce34100b76881ed4e704.png";